<template>
  <v-app id="app" v-if="isShow">
    <!-- 导航栏 -->
    <TopNavBar></TopNavBar>
    <!-- 侧边导航栏 -->
    <SideNavBar></SideNavBar>
    <!-- 内容 -->
    <v-main :class="{ 'v-main-simplify': this.$store.state.isSimplify }">
      <router-view :key="$route.fullPath" />
    </v-main>
    <!-- 页脚 -->
    <Footer></Footer>
    <!-- 返回顶部 -->
    <BackTop></BackTop>
    <!-- 搜索模态框 -->
    <!-- <searchModel></searchModel> -->
    <!-- 登录模态框 -->
    <LoginModel></LoginModel>
    <!-- 背景音模态框 -->
    <BgSoundModel></BgSoundModel>
    <!-- 注册模态框 -->
    <RegisterModel></RegisterModel>
    <!-- 忘记密码模态框 -->
    <ForgetModel></ForgetModel>
    <!-- 绑定邮箱模态框 -->
    <EmailModel></EmailModel>
    <!-- 音乐播放器 -->
    <!-- <Player v-if="blogInfo.webSite.isMusicPlayer === 1 && !isMobile" /> -->
    <!-- 聊天室 -->
    <ChatRoom v-if="0 == 1"></ChatRoom>
    <FeedBack />
    <Notify />
    <!-- 底部导航栏 -->
    <BottomNavBar></BottomNavBar>
    <!-- 一些小组件 -->
    <Widgets></Widgets>
  </v-app>
</template>

<script>
import TopNavBar from "./components/layout/TopNavBar";
import SideNavBar from "./components/layout/SideNavBar";
import BottomNavBar from "./components/layout/BottomNavBar";
import Footer from "./components/layout/Footer";
import BackTop from "./components/BackTop";
// import searchModel from "./components/model/SearchModel";
import LoginModel from "./components/model/LoginModel";
import BgSoundModel from "./components/model/BgSoundModel";
import RegisterModel from "./components/model/RegisterModel";
import ForgetModel from "./components/model/ForgetModel";
import EmailModel from "./components/model/EmailModel";
// import Player from "./components/zw-player/player.vue";
//import ChatRoom from "./components/ChatRoom";
import FeedBack from "./components/FeedBack";
import Notify from "./components/Notify";
import Widgets from "./components/layout/Widgets";
import { getWebSiteInfo, report } from "./api";

export default {
  data() {
    return {
      // 控制router-view的隐藏与显示
      isShow: true,
    };
  },
  provide() {
    // 提供可注入子组件属性
    return {
      reload: this.reload,
    };
  },
  mounted() {
    this.getBlogInfo();
    // 上传访客信息
    report();
  },
  components: {
    BgSoundModel,
    TopNavBar,
    // Player,
    SideNavBar,
    BottomNavBar,
    Footer,
    BackTop,
    // searchModel,
    LoginModel,
    RegisterModel,
    ForgetModel,
    EmailModel,
    FeedBack,
    Notify,
    Widgets,
  },
  methods: {
    getBlogInfo() {
      getWebSiteInfo().then((res) => {
        this.$store.commit("checkBlogInfo", res.data);
      });
    },
    reload() {
      // 定义加载方式
      // 先取消当前路由的视图展示，待dom重新渲染完毕，再让当前路由视图展示
      this.isShow = false;
      this.$nextTick(() => {
        this.isShow = true;
      });
    },
  },
  computed: {
    blogInfo() {
      return this.$store.state.blogInfo;
    },
    isMobile() {
      const clientWidth = document.documentElement.clientWidth;
      if (clientWidth > 760) {
        return false;
      }
      return true;
    },
  },
};
</script>
